import {
  Link,
  Links,
  LiveReload,
  Meta,
  Scripts,
  ScrollRestoration,
} from "@remix-run/react";
import { Button } from "./components/ui/button";
import { TextLogo } from "./routes/_index/components/Logo";

export const OurErrorBoundary = ({ error }: { error: unknown }) => {
  const message =
    error instanceof Error
      ? error.message
      : `${(error as any).status} - ${(error as any).statusText}`;

  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />

        <Meta />
        <Links />
      </head>
      <body className="min-h-screen flex items-center justify-center px-4">
        <div className="absolute top-0 left-0 p-4">
          <TextLogo className="text-2xl" />
        </div>

        <div className="max-w-3xl w-full bg-white rounded-3xl p-8 pt-4 text-center transform transition-all duration-300">
          <div className="mb-8">
            <img
              src="/error.svg"
              alt="Error Icon"
              className="max-w-xl mx-auto"
              width={500}
              height={500}
            />
          </div>

          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Uh-oh! Something went wrong
          </h1>

          <p className="text-gray-600 mb-8 text-lg leading-relaxed">
            {message}
          </p>

          <Link to="/">
            <Button className="text-white bg-red-500 hover:bg-red-600">
              Go back to the homepage
            </Button>
          </Link>
        </div>

        <ScrollRestoration />
        <Scripts />
        <LiveReload />
      </body>
    </html>
  );
};
